(ns ui.captions.pricing
  "The price estimate of a transcription in the captions sidebar: the
   customer price of a second (`:query/captions-pricing`) times the
   length of what the transcribe command will send, the whole media up
   to its limit (see `ui.captions.actions/transcription-range`)."
  (:require [app.openrouter.pricing :as openrouter-pricing]
            [parts.replicant.query :as query]))

(def pricing-query
  {:query/kind :query/captions-pricing})

(def max-transcription-ms
  "The limit of the transcribe command."
  (* 5 60 1000))

(defn pricing
  [state]
  (query/get-result state pricing-query))

(defn transcribed-ms
  "How much of the media the transcription covers: all of it, or the
   clip's range when the media is longer than the command accepts."
  [clip]
  (let [duration (get-in clip [:clip/asset :asset/duration])]
    (if (and duration
             (<= duration max-transcription-ms))
      duration
      (- (:clip/end clip)
         (:clip/start clip)))))

(defn duration-label
  "`1 min 10 s`, `45 s`, `2 min`: rounded to the second, since a
   `1:10` next to a price reads like a ratio."
  [ms]
  (let [seconds (js/Math.round (/ ms 1000))
        minutes (quot seconds 60)
        rest-seconds (mod seconds 60)]
    (cond
      (zero? minutes) (str seconds " s")
      (zero? rest-seconds) (str minutes " min")
      :else (str minutes " min " rest-seconds " s"))))

(defn estimate-label
  "`≈ $0.02 for 1 min 10 s of audio`, or nil while the price is unknown."
  [state clip]
  (when-let [usd-per-second (:captions/usd-per-second (pricing state))]
    (when-let [ms (some-> clip transcribed-ms)]
      (str "≈ " (openrouter-pricing/format-usd (* usd-per-second (/ ms 1000)))
           " for " (duration-label ms) " of audio"))))
